// src/services/useRegionView.js
import { useEffect, useRef, useState } from "react";
import { getMapViewByRegion } from "./getMapViewByRegion";

export function useRegionView() {
  const [view, setView] = useState(() =>
    getMapViewByRegion(localStorage.getItem("selectedRegion") || "ro")
  );

  const lastRef = useRef(localStorage.getItem("selectedRegion") || "ro");

  useEffect(() => {
    const apply = () => {
      const code = localStorage.getItem("selectedRegion") || "ro";
      if (code !== lastRef.current) {
        lastRef.current = code;
        setView(getMapViewByRegion(code));
      }
    };

    const onStorage = (e) => e.key === "selectedRegion" && apply();
    window.addEventListener("storage", onStorage);

    const id = setInterval(apply, 600);

    return () => {
      window.removeEventListener("storage", onStorage);
      clearInterval(id);
    };
  }, []);

  return view; // { center, zoom }
}
